// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__TARRM","colBig":"styles_colBig__1hbDK","colSmall":"styles_colSmall__25mFe"};